import { render, staticRenderFns } from "./AcceptanceTerm.vue?vue&type=template&id=78081d27&"
import script from "./AcceptanceTerm.vue?vue&type=script&lang=ts&"
export * from "./AcceptanceTerm.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptanceTerm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports